<template>
  <div :class="computedClasses" :id="navigatorItemId">
    <span
      v-for="(n, index) in indent"
      :key="`indent-${navigation.id}-${index}`"
      class="padding"
      >&#160;&#160;</span
    >
    <a @click="updateNavigation" :title="navigation.id">{{
      navigation.className
    }}</a>
  </div>
</template>

<script>
export default {
  name: "NavigatorItem",
  props: ["navigation", "indent", "selectedObjectId"],
  computed: {
    computedSelected() {
      return this.navigation &&
        this.selectedObjectId &&
        this.navigation.id == this.selectedObjectId
        ? true
        : false;
    },
    computedClasses() {
      if (this.computedSelected) {
        return " templateSelected";
      }
      return undefined;
    },
    navigatorItemId() {
      if (this.navigation == undefined) {
        return undefined;
      }
      return `navigatorItem${this.navigation.id}`;
    }
  },
  methods: {
    updateNavigation() {
      //   console.log(this.navigation);
      this.$emit("updateNavigation", this.navigation);
    }
  },
  watch: {
    navigation: {
      immediate: true,
      handler() {
        if (this.navigation) {
          if (!this.navigation.className) {
            console.log(this.navigation);
          }
        }
      }
    }
  }
};
</script>

